<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="Databases">
    <div class="tab-content">
      <div class="search">
        <app-search-field
          placeholder="Search website or database user"
          (searchText)="onDatabaseSearch($event)"
        >
        </app-search-field>
      </div>
      <div class="header row">
        <h2>Databases</h2>
        <div class="buttons row">
          <button matButton="filled" (click)="addDatabase()">
            <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
            Add Database
          </button>
        </div>
      </div>

      <mat-card appearance="outlined" class="table-container">
        @if (databases$ | async; as data) {
          <app-table
            #table
            [columns]="databasesColumns"
            [dataSource]="data.databases"
            [totalCount]="data.count"
            [expandableRows]="true"
            (pageChange)="handleDatabasePageEvent($event)"
          >
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let element">
                <app-status-label [status]="toStatus(element.status)"></app-status-label>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="icon-button users-list"
                    matTooltip="Database Users List"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    [disabled]="!element.users.length"
                    (click)="table.toggle(element)"
                  >
                    <fa-icon [icon]="['fas', 'list']" size="lg"></fa-icon>
                    <span>{{ element.users.length }}</span>
                  </button>

                  <button
                    matRipple
                    class="icon-button"
                    matTooltip="Add Database User"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="addDatabaseUser(element)"
                  >
                    <fa-icon [icon]="['fas', 'user-plus']" size="lg"></fa-icon>
                  </button>

                  <button
                    matRipple
                    class="icon-button"
                    matTooltip="Delete Database"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="deleteDatabase(element)"
                  >
                    <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-template #expandedRow let-row>
              <div class="expanded-row">
                <h2>Database Users</h2>

                <div class="expanded-table-container">
                  <app-table
                    [columns]="databaseUsersDetailsColumns"
                    [dataSource]="row.users"
                    [totalCount]="row.users.length"
                    [showPaginator]="false"
                  >
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                      <td mat-cell *matCellDef="let element">
                        <app-status-label
                          [status]="toUserStatus(element.status)"
                        ></app-status-label>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="buttons">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element">
                        <div class="buttons">
                          <button
                            matRipple
                            class="icon-button"
                            matTooltip="Database User Settings"
                            [matTooltipShowDelay]="500"
                            matTooltipPosition="above"
                            (click)="editDatabaseUser(element, row.id)"
                          >
                            <fa-icon [icon]="['fas', 'cog']" size="lg"></fa-icon>
                          </button>

                          <button
                            matRipple
                            class="icon-button"
                            matTooltip="Delete Database User"
                            [matTooltipShowDelay]="500"
                            matTooltipPosition="above"
                            (click)="deleteDatabaseUser(element)"
                          >
                            <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                  </app-table>
                </div>
              </div>
            </ng-template>
          </app-table>
        }
      </mat-card>
    </div>
  </mat-tab>

  <mat-tab label="Database Users">
    <div class="tab-content">
      <div class="search">
        <app-search-field
          placeholder="Search website or database user"
          (searchText)="onDatabaseUserSearch($event)"
        >
        </app-search-field>
      </div>

      <div class="header row">
        <h2>Database Users</h2>
        <div class="buttons row">
          <button matButton="filled" (click)="addDatabaseUserWithSelection()">
            <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
            Add Database User
          </button>
        </div>
      </div>

      <mat-card appearance="outlined" class="table-container">
        @if (databaseUsers$ | async; as data) {
          <app-table
            #table
            [columns]="databasesUsersColumns"
            [dataSource]="data.users"
            [totalCount]="data.count"
            [expandableRows]="true"
            (pageChange)="handleDatabaseUserPageEvent($event)"
          >
            <ng-container matColumnDef="databases">
              <th mat-header-cell *matHeaderCellDef>Databases</th>
              <td mat-cell *matCellDef="let element">
                <span>
                  {{ getDatabaseNames(element) }}

                  @if (element.databases.length > 3) {
                    <button type="button" class="more-button" (click)="table.toggle(element)">
                      +{{ element.databases.length - 3 }} more
                    </button>
                  }
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="website">
              <th mat-header-cell *matHeaderCellDef>Website</th>
              <td mat-cell *matCellDef="let element">
                {{ getWebsiteDomains(element) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="icon-button"
                    matTooltip="Database User Settings"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="editDatabaseUser(element)"
                  >
                    <fa-icon [icon]="['fas', 'cog']" size="lg"></fa-icon>
                  </button>

                  <button
                    matRipple
                    class="icon-button"
                    matTooltip="Delete Database User"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="deleteDatabaseUser(element)"
                  >
                    <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-template #expandedRow let-row>
              <div class="expanded-row">
                <h2>Databases for {{ row.username }}</h2>

                <div class="expanded-table-container">
                  <app-table
                    [columns]="userDatabasesColumns"
                    [dataSource]="getExpandedDatabases(row)"
                    [totalCount]="row.databases.length"
                    [showPaginator]="false"
                  >
                    <ng-container matColumnDef="buttons">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let element">
                        <div class="buttons">
                          <button matRipple class="icon-button" (click)="addDatabaseUser(element)">
                            <fa-icon [icon]="['fas', 'user-plus']" size="lg"></fa-icon>
                          </button>

                          <button matRipple class="icon-button" (click)="deleteDatabase(element)">
                            <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                  </app-table>
                </div>
              </div>
            </ng-template>
          </app-table>
        }
      </mat-card>
    </div>
  </mat-tab>
</mat-tab-group>
